export default __webpack_public_path__ + "static/media/gs8-waitlist-user-flow-th.b0f7a99c.jpg";